import { Copy, ExternalLink } from "lucide-react";
import type { LinkSafetyModalProps } from "streamdown";
import BaseDialog from "@/components/Modals/BaseDialog";
import { SpotToast } from "@/components/SpotToast";

export function ExternalLinkDialog({
  url,
  isOpen,
  onClose,
  onConfirm,
}: LinkSafetyModalProps) {
  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    SpotToast.success("Copied to clipboard");
  };

  const handleOpen = () => {
    onConfirm();
    onClose();
  };

  return (
    <BaseDialog
      title="Open external link?"
      description="You're about to visit an external website."
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      size="md"
      disableScroll
      footerActions={[
        {
          label: (
            <>
              <Copy className="size-4" />
              Copy link
            </>
          ),
          props: { variant: "outline", onClick: handleCopy },
        },
        {
          label: (
            <>
              <ExternalLink className="size-4" />
              Open link
            </>
          ),
          props: { onClick: handleOpen },
        },
      ]}
    >
      <div className="text-muted-foreground bg-muted wrap-anywhere rounded-md px-3 py-2.5 text-sm font-medium">
        {url}
      </div>
    </BaseDialog>
  );
}
